import { Component, input } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationProject } from '../../../../translation.service';
import { MandateStatus } from '../../services/dto/mandate-status';

export const mandateStatusLabel = (mandateStatus: MandateStatus) =>
  `project.mandateStatus.${MandateStatus[mandateStatus]?.toLowerCase() ?? 'unknown'}`;

@Component({
  selector: 'cam-mandate-status',
  templateUrl: './mandate-status.component.html',
  styleUrl: './mandate-status.component.scss',
  imports: [BadgeComponent, TranslatePipe],
})
export class MandateStatusComponent extends CamBaseComponent {
  status = input.required<number | MandateStatus>();

  constructor() {
    super();
    CamTranslationProject.getInstance();
  }

  public label() {
    return mandateStatusLabel(this.status());
  }

  public type() {
    switch (this.status()) {
      case MandateStatus.Pending:
      case MandateStatus.Created:
        return 'info';
      case MandateStatus.Active:
        return 'success';
      case MandateStatus.Failed:
        return 'danger';
      case MandateStatus.Revoked:
      default:
        return 'default';
    }
  }
}
